<template>
  <div class="title-box">
    <h1 class="main-title" v-html="titleInfo.mainTitle"></h1>
    <h2 class="sub-title">{{ titleInfo.subTitle }}</h2>
  </div>
</template>

<script>
export default {
  props: ['titleInfo']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.title-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 75px 0 46px 0;
  .main-title {
    margin-bottom: 26px;
    color: $font-color1;
    line-height: 1;
    font-size: $fontSize40;
    font-weight: 500;
  }
  .sub-title {
    color: $font-color2;
    line-height: 1;
    font-size: $fontSize24;
    font-weight: 400;
  }
}

@include mobile {
  .title-box {
    padding: 45px 20px 20px;
    .main-title {
      font-size: 25px;
      margin-bottom: 5px;
    }
    .sub-title {
      font-size: 16px;
      line-height: 28px;
      text-align: center;
    }
  }
}
</style>
